import React from "react";
import CampusImg from "../../assets/images/InternationalAcademy/campus.jpeg";
import HallImg from "../../assets/images/InternationalAcademy/hall.jpeg";
import AquaticImg from "../../assets/images/InternationalAcademy/aquatic.jpeg";
import FootballImg from "../../assets/images/InternationalAcademy/football.jpeg";
import PrimaryImg from "../../assets/images/InternationalAcademy/primary.jpeg";
import LibraryImg from "../../assets/images/InternationalAcademy/library.jpg";
import CorridorImg from "../../assets/images/InternationalAcademy/corrider.jpeg";
import PlayAreaImg from "../../assets/images/InternationalAcademy/outplayarea.jpeg";
import OutFootballImg from "../../assets/images/InternationalAcademy/outdoorfootbal.jpg";
import AdmissionImg from "../../assets/images/InternationalAcademy/adimission.jpg";
import KinderGartenImg from "../../assets/images/InternationalAcademy/playground.jpg";
import SandpitImg from "../../assets/images/InternationalAcademy/sandpit.jpg";

const Facilities = () => {
  const cardData = [
    {
      img: CampusImg,
      label: "Campus",
    },
    {
      img: HallImg,
      label: "Multi Purpose Hall",
    },
    {
      img: AquaticImg,
      label: "Aquatic Center",
    },
    {
      img: FootballImg,
      label: "Covered Football Pitch",
    },
    {
      img: PrimaryImg,
      label: "Primary Classrooms",
    },
    {
      img: LibraryImg,
      label: "Library",
    },
    {
      img: CorridorImg,
      label: "Primary School Corridor",
    },
    {
      img: PlayAreaImg,
      label: "Outdoor Play Area",
    },
    {
      img: OutFootballImg,
      label: "Outdoor Football Pitch",
    },
    {
      img: AdmissionImg,
      label: "Admission Area",
    },
    {
      img: KinderGartenImg,
      label: "Kindergarten Playground",
    },
    {
      img: SandpitImg,
      label: "Sandpit",
    },
  ];
  return (
    <div id="facilities">
      <div className="lg:px-14 px-5">
        <h1 className="text-center text-xl font-bold fontstyle2 pb-10">
          Facilities
        </h1>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1">
          {cardData.map((data) => {
            return (
              <ImageCard key={data.label} img={data.img} label={data.label} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Facilities;

const ImageCard = ({ img, label }) => {
  return (
    <div className="relative overflow-hidden">
      <img
        src={img}
        className="hover:scale-110 transition-all duration-500"
        alt=""
      />
      <p className=" absolute top-[45%] bg-purple-600/50 text-white px-5 py-2 fontstyle2 font-semibold text-xl">
        {label}
      </p>
    </div>
  );
};
